/**
 * Handle infinite scrolling of posts.
 *
 * This is the file that Webpack is compiling into loadmore.[hash].js
 */

import LoadMore from "./js/loadmore"; // 2KB

jQuery(function () {
  LoadMore.init();
});
